@if (areNauticalServicesApplicable(context.visit.portOfCall.port.locationUnCode)) {
  <div class="fieldset"
    [ngClass]="{'disabled' : disabled}">
    <!-- NUATICAL SERVICES (not last berth) -->
    @if (!isLastBerthVisitDeparture) {
      <!-- OUTBOUND NAUTICAL SERVICES AT CURRENT BERTH-->
      <div class="row">
        <!--Pilot (for entire movement)-->
        @if (hasPilots) {
          <div class="col-md-4">
            <app-edit-nautical-service [(ngModel)]="berthVisit.nextMovement.pilotService" type="Pilot"
              [serviceProviders]="pilotProvider" [berthVisit]="berthVisit"
              [required]="berthVisit.nextMovement.order && !berthVisit.atd && !context.hasDeparted()"
              [isLastMovement]="lastBerth">
            </app-edit-nautical-service>
          </div>
        }
        <!--Tugboat at departure-->
        @if (hasTugBoats || hasHelmsmen) {
          <div class="col-md-4">
            @if (context.visit.portOfCall.paDeclarationRequired) {
              <div class="fieldset" [ngClass]="{'disabled' :berthVisit.atd}"
                >
                @if (hasTugBoats) {
                  <app-edit-nautical-service
                    [(ngModel)]="berthVisit.tugboatAtDeparture" type="Tugboat"
                    (ngModelChange)="changeTugsAtArrival($event)"
                    [serviceProviders]="tugboatProvider" [berthVisit]="berthVisit"
                    [required]="berthVisit.nextMovement.order && !berthVisit.atd && !context.hasDeparted()">
                  </app-edit-nautical-service>
                }
                @if (hasHelmsmen) {
                  <app-edit-nautical-service class="d-block mt-3"
                    [(ngModel)]="berthVisit.helmsmenAtDeparture"
                    (ngModelChange)="changeHelmsmenAtArrival($event)"
                    type="Helmsmen" [serviceProviders]="helmsmenProvider" [berthVisit]="berthVisit"
                    [required]="berthVisit.nextMovement.order && !berthVisit.atd && !context.hasDeparted()">
                  </app-edit-nautical-service>
                }
              </div>
            }
          </div>
        }
        <!--Boatmen at departure-->
        @if (hasBoatmen) {
          <div class="col-md-4">
            @if (context.visit.portOfCall.paDeclarationRequired) {
              <div class="fieldset" [ngClass]="{'disabled' :berthVisit.atd}"
                >
                <app-edit-nautical-service [(ngModel)]="berthVisit.boatmenAtDeparture" type="Boatmen"
                  (ngModelChange)="changeBoatmenAtArrival($event)"
                  [serviceProviders]="boatmenProvider" [berthVisit]="berthVisit"
                  [required]="berthVisit.nextMovement.order && !berthVisit.atd && !context.hasDeparted()">
                </app-edit-nautical-service>
              </div>
            }
          </div>
        }
      </div>
      <!-- INBOUND NAUTICAL SERVICES AT NEXT BERTH -->
      @if (nextBerthVisit && (differentNauticalServices || showNauticalServicesAtArrival)) {
        <div class="row mt-4">
          <div class="col-md-4">
            <!-- Pilot always the same for entire movement -->
          </div>
          <!--Tugboat at arrival-->
          @if (hasHelmsmen || hasTugBoats) {
            <div class="col-md-4">
              @if (hasTugBoats) {
                <app-edit-nautical-service
                  [(ngModel)]="nextBerthVisit.tugboatAtArrival" type="Tugboat"
                  [berthVisit]="nextBerthVisit" [serviceProviders]="tugboatProvider"
                  [required]="berthVisit.nextMovement.order"
                  [id]="nextBerthVisit.id + '-tugboatToBerth'" [tugBoatsOnEntry]="firstBerth">
                </app-edit-nautical-service>
              }
              @if (hasHelmsmen) {
                <app-edit-nautical-service class="d-block mt-3"
                  [(ngModel)]="berthVisit.helmsmenAtArrival" type="Helmsmen"
                  [berthVisit]="nextBerthVisit" [serviceProviders]="helmsmenProvider"
                  [required]="berthVisit.nextMovement.order"
                  [id]="nextBerthVisit.id + '-helmsmenToBerth'" >
                </app-edit-nautical-service>
              }
            </div>
          }
          <!--Boatmen at arrival-->
          @if (hasBoatmen) {
            <div class="col-md-4">
              <app-edit-nautical-service [(ngModel)]="nextBerthVisit.boatmenAtArrival" type="Boatmen"
                [berthVisit]="nextBerthVisit" [serviceProviders]="boatmenProvider"
                [required]="berthVisit.nextMovement.order"
                [id]="nextBerthVisit.id + '-boatmenToBerth'">
              </app-edit-nautical-service>
            </div>
          }
        </div>
      }
      <!-- OPTION TO SPECIFY INBOUND NAUTICAL SERVICES AT NEXT BERTH -->
      <div class="row mt-2">
        <div class="col">
          <div class="fieldset" [ngClass]="{'disabled' :berthVisit.atd || (nextBerthVisit && nextBerthVisit.ata)}">
            <!--Order nautical services-->
            @if (!(lastBerth && this.context.visit.nextDeclarant)) {
              <div class="d-flex justify-content-end align-items-end">
                <div>
                  @if (nextBerthVisit && !(differentNauticalServices || showNauticalServicesAtArrival)) {
                    <a class="me-2 fst-italic" (click)="toggleNauticalServicesAtArrival()">Different nautical services at arrival</a>
                  }
                  @if (nextBerthVisit && (differentNauticalServices || showNauticalServicesAtArrival)) {
                    <a class="me-2 fst-italic" (click)="toggleNauticalServicesAtArrival()">Same nautical services at arrival</a>
                  }
                  @if (!berthVisit.atd && !lastBerth) {
                    <button class="btn btn-info me-1" (click)="copyMovement()">Copy movement</button>
                  }
                  @if (!berthVisit.atd && !lastBerth) {
                    <button class="btn btn-info me-1" (click)="copyNauticalServices()">Copy nautical services</button>
                  }
                  @if (context.visit.orderNauticalServices) {
                    @if (berthVisit.nextMovement.order) {
                      <button class="btn btn-danger" (click)="cancelMovement()">Cancel Order</button>
                    }
                    @if (!berthVisit.nextMovement.order && !!berthVisit.berth) {
                      <button class="btn btn-info"
                      (click)="orderMovement()">Order Movement</button>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- NUATICAL SERVICES (last berth) -->
    @if (isLastBerthVisitDeparture) {
      <div class="row always-enabled validate-for-next-declarant">
        @if (context.visit.nextVisitDeclaration?.lastBerthVisitDeparture; as lastBerthVisitDeparture) {
          <!--Pilot at departure-->
          @if (hasPilots) {
            <div class="col-md-4">
              <app-edit-nautical-service [(ngModel)]="lastBerthVisitDeparture.nextMovement.pilotService" type="Pilot"
                [serviceProviders]="pilotProvider" [berthVisit]="berthVisit"
                [isLastMovement]="lastBerth">
              </app-edit-nautical-service>
            </div>
          }
          <!--Tugboat at departure-->
          @if (hasTugBoats) {
            <div class="col-md-4 border-start border-end">
              @if (context.visit.portOfCall.paDeclarationRequired) {
                <div class="fieldset" [ngClass]="{'disabled' :berthVisit.atd}"
                  >
                  <app-edit-nautical-service [(ngModel)]="lastBerthVisitDeparture.tugboatAtDeparture" type="Tugboat"
                    [serviceProviders]="tugboatProvider"
                  [berthVisit]="berthVisit"></app-edit-nautical-service>
                </div>
              }
            </div>
          }
          <!--Boatmen at departure-->
          @if (hasBoatmen) {
            <div class="col-md-4">
              <app-edit-nautical-service [(ngModel)]="lastBerthVisitDeparture.boatmenAtDeparture" type="Boatmen"
                [serviceProviders]="boatmenProvider"
              [berthVisit]="berthVisit"></app-edit-nautical-service>
            </div>
          }
        }
      </div>
      @if (nextBerthVisit) {
        <div class="row always-enabled">
          <div class="col-md-4">
            <span class="text-secondary">Arrival at {{nextBerthVisit.berth?.name}}</span>
          </div>
          <!--Tugboat at arrival-->
          @if (hasTugBoats) {
            <div class="col-md-4 border-end">
              <app-edit-nautical-service [(ngModel)]="nextBerthVisit.tugboatAtArrival" type="Tugboat"
                [berthVisit]="nextBerthVisit" [serviceProviders]="tugboatProvider"
                [id]="nextBerthVisit.id + '-tugboatToBerth'" [tugBoatsOnEntry]="firstBerth">
              </app-edit-nautical-service>
            </div>
          }
          <!--Boatmen at arrival-->
          @if (hasBoatmen) {
            <div class="col-md-4">
              <app-edit-nautical-service [(ngModel)]="nextBerthVisit.boatmenAtArrival" type="Boatmen"
                [berthVisit]="nextBerthVisit" [serviceProviders]="boatmenProvider"
                [id]="nextBerthVisit.id + '-boatmenToBerth'">
              </app-edit-nautical-service>
            </div>
          }
        </div>
      }
    }
  </div>
}
